import { ThankYouType } from '../../shared/enums/thank-you-type.enum';
import { BehaviorSubject, Observable } from 'rxjs';
import { FeedbackMapper } from '../../feedback-mapper';
import { Feedback } from '../feedback/feedback.model';

// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class Step {
  public position!: number;

  public totalQuestions!: number;

  public set feedback(value: Feedback | undefined) {
    this.#feedback$.next(value);
  }

  public get feedback(): Feedback | undefined {
    return this.#feedback$.value;
  }

  readonly #feedback$: BehaviorSubject<Feedback | undefined> =
    new BehaviorSubject<Feedback | undefined>(undefined);

  public readonly feedback$: Observable<Feedback | undefined> =
    this.#feedback$.asObservable();

  public thankYouType!: ThankYouType;

  protected static mapBaseProperties(step: Step, dto: any): void {
    step.position = dto.position;
    step.totalQuestions = dto.totalQuestions;
    step.feedback = dto.feedback
      ? FeedbackMapper.fromDto(dto.feedback)
      : undefined;
  }

  /**
   * Returns true if this is the last question of a questionnaire.
   *
   * Note: This does not take into account any conditions since we don't have this
   * kind of information available in the client.
   */
  public get isAtEnd(): boolean {
    return this.position === this.totalQuestions;
  }
}
